// /in-stock — dynamic PLP of every product with a variant qty > 0.
import { useEffect } from 'react';
import TopUtilityBar from '../sections/TopUtilityBar';
import MainHeader from '../sections/MainHeader';
import Footer from '../sections/Footer';
import { useCanonical, useSeoMeta } from '../lib/seo';
import { useInStock, InStockCard, InStockFallback } from '../components/storefront/InStock';

export default function InStockPage() {
        useCanonical('/in-stock');
        const { loading, count, products } = useInStock(0);
        useSeoMeta({
                title: 'In Stock Gaming Gear — Ships in 2–4 Days | Loadout India',
                description: 'Gaming keyboards, mice and mousepads in stock in India right now — ready to dispatch in 2–4 days from Loadout, with UPI and 18-month warranty.',
                path: '/in-stock',
        });
        return (
                <div className="min-h-screen bg-[#0A0A0A] text-white">
                        <TopUtilityBar />
                        <MainHeader />
                        <main data-testid="in-stock-page" className="mx-auto max-w-[1440px] px-6 py-12 md:py-16">
                                <div className="border-b border-[#1F1F1F] pb-8 md:pb-10">
                                        <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#FF9F1C]">READY TO SHIP</div>
                                        <h1 className="mt-3 font-display text-[36px] md:text-[56px] leading-[0.95]">IN STOCK.</h1>
                                        <p className="mt-4 font-sans text-[15px] md:text-[16px] text-[#8A8A8A] leading-relaxed max-w-[640px]">
                                                Every product with units on our shelf right now. Items drop off automatically when they sell through.
                                        </p>
                                        {!loading && count > 0 && (
                                                <p data-testid="in-stock-count" className="mt-4 font-mono text-[11px] uppercase tracking-[0.16em] text-white/50">{count} products</p>
                                        )}
                                </div>
                                <div className="mt-10">
                                        {loading ? (
                                                <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-white/40">Loading…</p>
                                        ) : products.length === 0 ? (
                                                <InStockFallback />
                                        ) : (
                                                <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
                                                        {products.map((p) => <InStockCard key={p.handle} p={p} />)}
                                                </div>
                                        )}
                                </div>
                        </main>
                        <Footer />
                </div>
        );
}
